/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Correct_Logged_SetsInputs */

const en_us2_workout_correct_logged_sets = /** @type {(inputs: Workout_Correct_Logged_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logged sets`)
};

const pt_br2_workout_correct_logged_sets = /** @type {(inputs: Workout_Correct_Logged_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries registradas`)
};

const es_419_workout_correct_logged_sets = /** @type {(inputs: Workout_Correct_Logged_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series registradas`)
};

const pt_pt2_workout_correct_logged_sets = /** @type {(inputs: Workout_Correct_Logged_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries registadas`)
};

const fr_fr2_workout_correct_logged_sets = /** @type {(inputs: Workout_Correct_Logged_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries enregistrées`)
};

const de_de2_workout_correct_logged_sets = /** @type {(inputs: Workout_Correct_Logged_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfasste Sätze`)
};

const it_it2_workout_correct_logged_sets = /** @type {(inputs: Workout_Correct_Logged_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie registrate`)
};

/**
* | output |
* | --- |
* | "Logged sets" |
*
* @param {Workout_Correct_Logged_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_correct_logged_sets = /** @type {((inputs?: Workout_Correct_Logged_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Correct_Logged_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_correct_logged_sets(inputs)
	if (locale === "es-419") return es_419_workout_correct_logged_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_correct_logged_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_correct_logged_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_correct_logged_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_correct_logged_sets(inputs)
	return en_us2_workout_correct_logged_sets(inputs)
});
export { workout_correct_logged_sets as "workout.correct_logged_sets" }